import { showConfirmDialog } from 'vant'

export const PWD_REMIND_SESSION_KEY = 'pwd_remind_dialog_shown'

export const PWD_REMIND_MESSAGE =
  'Please update your password regularly to keep your account secure.'

export const clearPwdRemindSession = () => {
  sessionStorage.removeItem(PWD_REMIND_SESSION_KEY)
}

/**
 * 登录会话内仅弹一次；「稍后」只关弹窗，轮播仍可显示。
 * 样式跟随 App：主色 #ff9f00（与 --primary-color 一致）。
 */
export const maybeShowPwdRemindDialog = (needRemind, router, changePwdPath = '/resetpwd') => {
  if (!needRemind) return
  if (sessionStorage.getItem(PWD_REMIND_SESSION_KEY)) return
  sessionStorage.setItem(PWD_REMIND_SESSION_KEY, '1')
  showConfirmDialog({
    title: 'Password Reminder',
    message: PWD_REMIND_MESSAGE,
    confirmButtonText: 'Change Password',
    cancelButtonText: 'Later',
    theme: 'round-button',
    className: 'app-confirm-dialog',
    confirmButtonColor: '#ff9f00',
  })
    .then(() => {
      router.push(changePwdPath)
    })
    .catch(() => {})
}
